/** Fetch state of uploaded files */
export enum FetchState {
  idle = 'idle',
  pending = 'pending',
  success = 'success',
  failure = 'failure',
}
